import { render, staticRenderFns } from "./AggregatedCards.vue?vue&type=template&id=0cffb593&scoped=true"
import script from "./AggregatedCards.vue?vue&type=script&lang=js"
export * from "./AggregatedCards.vue?vue&type=script&lang=js"
import style0 from "./AggregatedCards.vue?vue&type=style&index=0&id=0cffb593&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cffb593",
  null
  
)

export default component.exports